import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  // Generate metadata via OpenAI (by videoId or scriptId)
  publicationGenerateMetadataRequest: ['videoId', 'callback'],
  publicationGenerateMetadataSuccess: ['metadata'],
  publicationGenerateMetadataFailure: ['error'],

  // Generate metadata by script (no video needed)
  publicationGenerateMetadataByScriptRequest: ['scriptId', 'callback'],

  // Save metadata to backend
  publicationSaveMetadataRequest: ['scriptId', 'platforms', 'callback'],
  publicationSaveMetadataSuccess: ['data'],
  publicationSaveMetadataFailure: ['error'],

  // Load saved metadata from backend
  publicationLoadMetadataRequest: ['scriptId', 'callback'],
  publicationLoadMetadataSuccess: ['data'],
  publicationLoadMetadataFailure: ['error'],

  // Create publication
  publicationCreateRequest: ['videoId', 'params', 'callback'],
  publicationCreateSuccess: ['data'],
  publicationCreateFailure: ['error'],

  // Send email
  publicationSendEmailRequest: ['videoId', 'publicationId', 'email', 'callback'],
  publicationSendEmailSuccess: ['data'],
  publicationSendEmailFailure: ['error'],

  // List publications
  publicationListRequest: ['videoId', 'callback'],
  publicationListSuccess: ['list'],
  publicationListFailure: ['error'],

  // Reset
  publicationReset: [],
})

export const PublicationTypes = Types
export default Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  // Metadata generation
  metadataFetching: false,
  metadata: null,
  metadataError: null,

  // Create
  createFetching: false,
  created: null,
  createError: null,

  // Send email
  sendingEmail: false,
  sendEmailResult: null,
  sendEmailError: null,

  // Save
  saving: false,
  saveError: null,

  // Load
  loading: false,
  loadError: null,

  // List
  list: [],
  listFetching: false,
  listError: null,
}

/* ------------- Reducer ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Generate metadata
    case Types.PUBLICATION_GENERATE_METADATA_REQUEST:
      return { ...state, metadataFetching: true, metadataError: null }
    case Types.PUBLICATION_GENERATE_METADATA_SUCCESS:
      return { ...state, metadataFetching: false, metadata: action.metadata, metadataError: null }
    case Types.PUBLICATION_GENERATE_METADATA_FAILURE:
      return { ...state, metadataFetching: false, metadataError: action.error }

    // Save metadata
    case Types.PUBLICATION_SAVE_METADATA_REQUEST:
      return { ...state, saving: true, saveError: null }
    case Types.PUBLICATION_SAVE_METADATA_SUCCESS:
      return { ...state, saving: false, saveError: null }
    case Types.PUBLICATION_SAVE_METADATA_FAILURE:
      return { ...state, saving: false, saveError: action.error }

    // Load metadata
    case Types.PUBLICATION_LOAD_METADATA_REQUEST:
      return { ...state, loading: true, loadError: null }
    case Types.PUBLICATION_LOAD_METADATA_SUCCESS:
      return { ...state, loading: false, metadata: action.data, loadError: null }
    case Types.PUBLICATION_LOAD_METADATA_FAILURE:
      return { ...state, loading: false, loadError: action.error }

    // Create
    case Types.PUBLICATION_CREATE_REQUEST:
      return { ...state, createFetching: true, createError: null }
    case Types.PUBLICATION_CREATE_SUCCESS:
      return { ...state, createFetching: false, created: action.data, createError: null }
    case Types.PUBLICATION_CREATE_FAILURE:
      return { ...state, createFetching: false, createError: action.error }

    // Send email
    case Types.PUBLICATION_SEND_EMAIL_REQUEST:
      return { ...state, sendingEmail: true, sendEmailError: null }
    case Types.PUBLICATION_SEND_EMAIL_SUCCESS:
      return { ...state, sendingEmail: false, sendEmailResult: action.data, sendEmailError: null }
    case Types.PUBLICATION_SEND_EMAIL_FAILURE:
      return { ...state, sendingEmail: false, sendEmailError: action.error }

    // List
    case Types.PUBLICATION_LIST_REQUEST:
      return { ...state, listFetching: true, listError: null }
    case Types.PUBLICATION_LIST_SUCCESS:
      return { ...state, list: action.list, listFetching: false, listError: null }
    case Types.PUBLICATION_LIST_FAILURE:
      return { ...state, listFetching: false, listError: action.error }

    // Reset
    case Types.PUBLICATION_RESET:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}
